import axios from "axios";
import { BaseUrl } from "./bassUrl";

/**
 * Submits a customer / contact query to the backend API.
 * Sends the role selected by the user ("user", "facility_manager", or "coach").
 *
 * @param {Object} queryData
 * @param {string} queryData.name
 * @param {string} queryData.email
 * @param {string} queryData.role
 * @param {string} queryData.message
 * @returns {Promise<Object>}
 */
export const submitCustomerQuery = async ({ name, email, role, message }) => {
  const baseUrl = BaseUrl();
  const response = await axios.post(`${baseUrl}/customer-query`, {
    name: name.trim(),
    email: email.trim(),
    role: role || "user",
    message: message.trim(),
  });
  return response.data;
};
